import {Component, Input, inject} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatChipsModule} from '@angular/material/chips';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {FilterService} from '../../../services/filter.service';
import {CurrentSelectionDisplay} from '../../../models/current-selection-display';

@Component({
  selector: 'app-filter-chip-overflow',
  templateUrl: './filter-chip-overflow.component.html',
  styleUrls: ['./filter-chip-overflow.component.scss'],
  standalone: true,
  imports: [MatButtonModule, MatChipsModule, MatIconModule, MatMenuModule],
})
export class FilterChipOverflowComponent {
  filterService = inject(FilterService);

  @Input() overflowingCurrentSelections: CurrentSelectionDisplay[] = [];
}
